import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { getValueFormatter as getValueFormatterBase } from '../value-formatter';

export const getValueFormatter = (field: FilterableField) => {
  return getValueFormatterBase(field);
};
